import styled from 'styled-components'

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: ${props => {
    switch (props.columns) {
      case 2:
        return 'repeat(2, 1fr)'
      case 3:
        return '1fr 1fr 1fr'
      case 5:
        return 'repeat(5, 1fr)'
      default:
        return '1fr'
    }
  }};
  gap: ${props => props.gap || '1rem'};

  ${props =>
    props.columns === 5 &&
    `
    @media (max-width: 1200px) {
      grid-template-columns: repeat(4, 1fr);
    }
    @media (max-width: 1000px) {
      grid-template-columns: repeat(3, 1fr);
    }
  `}

  ${props =>
    props.columns >= 3 &&
    `
    @media (max-width: 768px) {
      grid-template-columns: ${props.columns === 5 ? 'repeat(2, 1fr)' : '1fr'};
    }
  `}

  ${props =>
    props.columns === 5 &&
    `
    @media (max-width: 500px) {
      grid-template-columns: 1fr;
    }
  `}

  ${props =>
    props.columns === 2 &&
    `
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  `}
`
